import React from 'react';

import { Flex } from 'Components/Base';

const IconComponent = ({ iconComponent, ...restProps }) => {
  return (
    <Flex
      width={'46px'}
      alignItems={'center'}
      justifyContent={'center'}
      style={{ height: '52px', minWidth: '46px' }}
      {...restProps}
    >
      {iconComponent}
    </Flex>
  );
};

export default IconComponent;
